<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="query"
              type="search"
              :placeholder="
                $l('form_label_search') || '品牌名称/品牌介绍搜索...'
              "
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="650px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brand_name') || '品牌名称'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.brandName"
                :placeholder="
                  $l('form_label_pe_brand_name') || '请输入品牌名称'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brand_desc') || '品牌介绍'">
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.brandDesc"
                :placeholder="
                  $l('form_label_pe_brand_desc') || '请输入品牌介绍'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_has_E-commerce_brand') || '是否有电商品牌'"
              prop="isEcom"
            >
              <br />
              <el-radio-group v-model="form.isEcom">
                <el-radio label="Y">{{ $l('INDEX.YES') || '是' }}</el-radio>
                <el-radio label="N">{{ $l('INDEX.NO') || '否' }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_Ecommerce_brand_number') || '电商品牌编号'"
            >
              <el-input
                style="width: 100%"
                clearable
                size="small"
                v-model="form.ecomBrandNo"
                maxlength="2"
                show-word-limit
                @input="
                  (e) => {
                    formData.ecomBrandNo = toUppercase(e)
                  }
                "
                :placeholder="
                  $l('form_placeholder_Ecommerce_brand_number') ||
                    '请输入电商品牌编号'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brand_status') || '状态'">
              <el-checkbox-group v-model="form.brandStatusList">
                <el-checkbox label="Y">{{
                  $l('INDEX.form_label_valid') || '有效'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('INDEX.form_label_invalid') || '无效'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="onReset">{{
          $l('INDEX.btn_reset_filter ') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="query">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  brandStatusList: ['Y'],
}

export default {
  data() {
    return {
      visible: false,
      form: {
        ...initForm,
      },
    }
  },
  methods: {
    onReset() {
      this.form = { ...initForm }
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    reset() {
      this.query()
    },
    closeDialog() {
      this.visible = false
    },
    toUppercase(e) {
      return e.replace(/[^A-z]*/g, '').toLocaleUpperCase()
    },
  },
  mounted() {
    this.$emit('reset')
    this.query()
  },
}
</script>
